import { OverlayModule } from '@angular/cdk/overlay';
import { AsyncPipe, NgClass, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { PortfolioTaskListComponent } from '@features/portfolio-task-list/portfolio-task-list.component';

import { UserTasksQuery } from '@models/user-tasks';

import { IconComponent } from '@shared/components/icon/icon.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [OverlayModule, AsyncPipe, NgClass, IconComponent, PortfolioTaskListComponent, NgStyle],
  selector: 'aux-trial-tasks',
  styles: [],
  templateUrl: './trial-tasks.component.html',
})
export class TrialTasksComponent {
  private userTasksQuery = inject(UserTasksQuery);

  isOpen = false;
  noMessage = 'You have no tasks to complete at this time';
  trialTasks$ = this.userTasksQuery.getCurrentTrialTasks();

  toggleOpenList = (value: boolean) => {
    this.isOpen = value;
  };
}
